// eslint-disable-next-line import/prefer-default-export
export const formatURL = (url: string) => {
  const { origin, pathname, search } = new URL(url);
  return `${origin}${pathname}${search}`;
};
